/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Metapic Internal Payments API Documentation
 * <p>API documentation for Metapic internal APIs. This documentation covers payment-related endpoints including payment summaries, cost summaries, payout history, and general payment operations.</p>
      <h2>Authentication</h2>
      <p>This API uses <strong>Bearer Token</strong> authentication. You must include a valid token in the <strong>Authorization</strong> header with every request to access protected endpoints.</p>
      <h4>Example:</h4>
      <pre>Authorization: Bearer <i>your_token_here</i></pre>
      <p>*Replace <i>your_token_here</i> with your actual Bearer token. All API requests require this token for authentication.</p>
 * OpenAPI spec version: 1.0
 */
import * as axios from 'axios'
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios'

import type { PaymentSummary } from '../metapicInternalPaymentsAPIDocumentation.schemas'

export const getPaymentSummary = (axiosInstance: AxiosInstance = axios.default) => {
  /**
   * @summary Get a summary of the creator's current payment situation
   */
  const paymentSummaryControllerGetPaymentSummary = (
    userId: number,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<PaymentSummary>> => {
    return axiosInstance.get(`/users/${userId}/creator/payment-summary`, options)
  }
  return { paymentSummaryControllerGetPaymentSummary }
}
export type PaymentSummaryControllerGetPaymentSummaryResult = AxiosResponse<PaymentSummary>
